/** @format */

// App.js
import React from "react";
import Header from "./Header"; // Assuming Header is in the same directory
import Specialities from "./Specialities"; // Import Specialities component
import Doctors from "./Doctors";
import ClinicGallery from "./ClinicGallery";
import Footer from "./Footer";
import VideoSection from "./VideoSection";

function MainComponent() {
	return (
		<div className="App">
			<Header />
			{/* <Specialities /> */}
			<Doctors />
			<ClinicGallery />
			<VideoSection />
			<Footer />
		</div>
	);
}

export default MainComponent;
